import { render, staticRenderFns } from "./select-people-nubixar.vue?vue&type=template&id=997da78c"
import script from "./select-people-nubixar.vue?vue&type=script&lang=js"
export * from "./select-people-nubixar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports